"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var Notifications = function Notifications(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M3.99878 19.25V17.25H5.99878V10.25C5.99878 8.86667 6.41545 7.6375 7.24878 6.5625C8.08211 5.4875 9.16545 4.78333 10.4988 4.45V3.75C10.4988 3.33333 10.6446 2.97917 10.9363 2.6875C11.2279 2.39583 11.5821 2.25 11.9988 2.25C12.4154 2.25 12.7696 2.39583 13.0613 2.6875C13.3529 2.97917 13.4988 3.33333 13.4988 3.75V4.45C14.8321 4.78333 15.9154 5.4875 16.7488 6.5625C17.5821 7.6375 17.9988 8.86667 17.9988 10.25V17.25H19.9988V19.25H3.99878ZM11.9988 22.25C11.4488 22.25 10.9779 22.0542 10.5863 21.6625C10.1946 21.2708 9.99878 20.8 9.99878 20.25H13.9988C13.9988 20.8 13.8029 21.2708 13.4113 21.6625C13.0196 22.0542 12.5488 22.25 11.9988 22.25Z",
    fill: "currentColor"
  }));
};

var _default = Notifications;
exports.default = _default;